import { useEffect, useState } from 'react'

// Lee un número desde un endpoint (número o { value }) y lo refresca cada cierto tiempo.
// Sin endpoint, devuelve el valor de respaldo e isLive = false.
export function useRemoteNumber(
  endpoint: string | null,
  fallback: number,
  pollMs = 30000,
): { value: number; isLive: boolean } {
  const [value, setValue] = useState(fallback)
  const [isLive, setIsLive] = useState(false)

  useEffect(() => {
    if (!endpoint) return
    let cancelled = false
    const load = async () => {
      try {
        const res = await fetch(endpoint)
        if (!res.ok) throw new Error('Respuesta inválida')
        const data: unknown = await res.json()
        const n =
          typeof data === 'number'
            ? data
            : typeof data === 'object' && data !== null && 'value' in data
              ? Number((data as { value: unknown }).value)
              : NaN
        if (!cancelled && Number.isFinite(n)) {
          setValue(n)
          setIsLive(true)
        }
      } catch {
        if (!cancelled) setIsLive(false)
      }
    }
    load()
    const id = setInterval(load, pollMs)
    return () => {
      cancelled = true
      clearInterval(id)
    }
  }, [endpoint, pollMs])

  return { value, isLive }
}
